export const CnDefaultLocationTargetsViewModel = {
  bidMode: false,
  currentLevelSettings: {
    currentLocations: [{
      Criterion: {
        BidAdjustment: 0,
        LocationCriterion: {
          CountryCode: 'CN',
          Latitude: 36.5594,
          LesLocationType: 'Country',
          LocationId: 39,
          LocationType: 'Country',
          Longitude: 103.753,
          Name: 'China',
          NameTypeCombo: 'China (country/region)',
          Type: 'Location',
        },
        OriginalBidAdjustment: 0,
        OriginalCashbackPercent: undefined,
        Type: 'Location',
      },
      CriterionType: 'Location',
      Id: undefined,
      SelectionStatus: 'Included',
      Status: 'Active',
      bidAdjustmentDropdown: 'Increase by',
      bidAdjustmentInput: 0,
      location: 'China (country/region)',
    }],
    initLocations: [],
    peopleInLocation: true,
    peopleSearchingForLocation: true,
    targetOption: 'specific',
  },
  parentLevelSettings: {},
  useParentLevel: false,
};

export const globalDefaultLocationTargetsViewModel = {
  bidMode: false,
  currentLevelSettings: {
    initLocations: [],
    peopleInLocation: true,
    peopleSearchingForLocation: true,
    targetOption: 'everywhere',
  },
  parentLevelSettings: {},
  useParentLevel: false,
};

export const getDefaultLocationTargetsViewModel = isCnMarket => (isCnMarket ? CnDefaultLocationTargetsViewModel : globalDefaultLocationTargetsViewModel);

export const getDefaultLanguagesViewModel = isCnMarket => (isCnMarket ? ['SimplifiedChinese'] : ['All']);
